import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import SvgMascotte from "@Components/CustomIcon/SvgMascotte"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { AppointmentCardItem } from "@Components/FollowUp/Appointment/AppointmentCardItem"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { userAtom } from "@Recoil/Atom/userAtom"
import React, { useEffect, useState } from "react"
import { FlatList, RefreshControl, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { useRecoilValue } from "recoil"
import { useUserAppointmentRQHooks } from "../../../Hooks/ReactQueryHooks/useUserAppointmentRQHooks"

export const AppointmentHome = ({ navigation, route }) => {
    const user = useRecoilValue(userAtom)
    const [appointements, setAppointments] = useState([])
    const [loading, setLoading] = useState(false)
    const [updateList, setUpdateList] = useState(false)
    const { data, isLoading, refetch } = useUserAppointmentRQHooks()

    useEffect(() => {
        if (data?.length > 0) {
            let events = data?.filter((item) => item?.eventType?.isConsulation)
            setAppointments(events)
        }
    }, [data])

    useEffect(() => {
        refetch()
    }, [updateList])

    const distinctData = appointements ?? []
    const isEmpty = data?.length === 0

    return (
        <ContainerStackScreen>
            <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                Entretiens de suivi/évaluation
            </BreeSerifText>
            <CustomScrollview>
                {isEmpty && (
                    <>
                        <Spacer height={15} />
                        <OpenSansText fontSize={14}>
                            Planifiez des entretiens en visio avec certains professionnels en fonction de vos besoins
                            tout au long de votre parcours.`
                        </OpenSansText>
                    </>
                )}

                {isLoading ? (
                    <ActivityIndicator color={baseColors.green.primary} size={"large"} style={{ margin: 40 }} />
                ) : isEmpty ? (
                    <>
                        <SvgMascotte style={{ marginVertical: 20, alignSelf: "center" }} width={278} height={278} />
                        <OpenSansText fontSize={14} textAlign={"center"}>
                            Vous n'avez aucun entretien programmé pour le moment.
                        </OpenSansText>
                    </>
                ) : (
                    <View>
                        <Spacer height={20} />
                        <FlatList
                            showsVerticalScrollIndicator={false}
                            data={distinctData ?? []}
                            contentContainerStyle={{
                                paddingTop: 20,
                                paddingBottom: 150
                            }}
                            ListHeaderComponent={
                                <OpenSansText fontSize={14}>
                                    Entretiens de suivi/évaluation Au vu de votre avancée dans le programme, nous vous
                                    proposons de planifier un entretien d'évaluation selon les horaires qui vous
                                    conviennent
                                </OpenSansText>
                            }
                            renderItem={({ item }) => (
                                <AppointmentCardItem
                                    {...item}
                                    onPress={() => navigation.navigate("AppointmentDetails", { data: item })}
                                    isVisio={item?.isVisio ?? undefined}
                                    visioContent={item?.isVisio ? item?.visioconference : undefined}
                                    setUpdateList={setUpdateList}
                                    name={item?.eventType?.name}
                                />
                            )}
                            keyExtractor={(item) => item?.id.toString()}
                            refreshControl={<RefreshControl refreshing={isLoading} onRefresh={() => refetch()} />}
                        />
                    </View>
                )}

                <Spacer height={15} />
            </CustomScrollview>

            <Button
                onPress={() => navigation.navigate("AppointmentForm")}
                text="Programmer un rdv"
                width="80%"
                disabled={loading}
                backgroundColor={baseColors.green.primary}
                labelColor={"white"}
            />
        </ContainerStackScreen>
    )
}
